module.exports = __webpack_public_path__ + "img/m3.d44efa49.png";